//List of allowed countries - Source: https://skopei.atlassian.net/browse/TP-3128

export const languages = [
	{
		code: 'nl',
		language: 'dutch',
	},
	{
		code: 'de',
		language: 'german',
	},
	{
		code: 'en',
		language: 'english',
	},
];

export const categories = {
	BIKES: 1,
	OFFICES: 2,
	CARS: 3,
	TRAILERS: 4,
	PARKINGLOTS: 5,
	ASSETS: 6,
	BOATS: 7,
};

export const exportType = {
	XLSX: 'xlsx',
	CSV: 'csv',
};

export const licensePlateLength = 12;
